import { ForbiddenError } from "./ForbiddenError.js";
class RefExpiredError extends ForbiddenError {
}
export {
  RefExpiredError
};
//# sourceMappingURL=RefExpiredError.js.map
